import React, { useEffect, useState } from 'react';
import { moduleApi } from '../../lib/api';
import { oublierValiditeDevis } from './devisPrestationPdfGenerator';

/** Onglet « Délais » des réglages de Dossiers : au bout de N jours sans réponse, un devis envoyé est abandonné (0 = jamais). */
export function ParametresDelais() {
    const [jours, setJours] = useState<number | null>(null);
    const [actif, setActif] = useState(false);
    const [validite, setValidite] = useState(30);
    const [engage, setEngage] = useState(true);
    const [message, setMessage] = useState('');
    useEffect(() => {
        moduleApi.getPrestationDelais().then((r: any) => { const n = Number(r?.devis_abandon_jours) || 0; setJours(n > 0 ? n : 30); setActif(n > 0); setValidite(Number(r?.devis_validite_jours) > 0 ? Number(r.devis_validite_jours) : 30); setEngage(r?.devis_engage_client !== false); }).catch(() => setJours(30));
    }, []);
    const enregistrer = async (nextActif: boolean, nextJours: number) => {
        setMessage('');
        try {
            const res: any = await moduleApi.savePrestationDelais({ devis_abandon_jours: nextActif ? nextJours : 0 });
            setMessage(res?.error ? res.error : 'Enregistré.');
        } catch (e: any) { setMessage(e?.message || "L'enregistrement a échoué."); }
    };
    const enregistrerEngagement = async (v: boolean) => {
        setMessage('');
        try {
            const res: any = await moduleApi.savePrestationDelais({ devis_engage_client: v });
            if (!res?.error) oublierValiditeDevis();
            setMessage(res?.error ? res.error : 'Enregistré.');
        } catch (e: any) { setMessage(e?.message || "L'enregistrement a échoué."); }
    };
    const enregistrerValidite = async (n: number) => {
        setMessage('');
        try {
            const res: any = await moduleApi.savePrestationDelais({ devis_validite_jours: n });
            if (!res?.error) oublierValiditeDevis();
            setMessage(res?.error ? res.error : 'Enregistré.');
        } catch (e: any) { setMessage(e?.message || "L'enregistrement a échoué."); }
    };
    if (jours === null) return null;
    return (
        <div className="space-y-3">
            <section className="space-y-3 p-4 rounded-2xl bg-surface-soft border border-border">
                <div>
                    <h3 className="text-sm font-bold text-content">Validité du devis</h3>
                    <p className="text-[11px] text-content-muted mt-0.5">Durée écrite sur chaque devis (« Devis valable … jours »).</p>
                </div>
                <label className="flex items-center gap-2 text-sm text-content">
                    Valable
                    <input type="number" min={1} max={365} className="w-20 bg-surface border border-border rounded-xl px-3 py-2 text-sm text-content outline-none focus:border-brand-500" value={validite}
                        onChange={(e) => setValidite(Math.max(1, Math.min(365, Number(e.target.value) || 1)))} onBlur={() => enregistrerValidite(validite)} />
                    jours
                </label>
            </section>
            <section className="space-y-3 p-4 rounded-2xl bg-surface-soft border border-border">
                <div>
                    <h3 className="text-sm font-bold text-content">Engagement du devis</h3>
                    <p className="text-[11px] text-content-muted mt-0.5">Activé : signer le devis engage le client (« bon pour accord », il vaut commande). Désactivé : devis sans engagement. Le devis et sa page de signature le disent, et signer signifie « je valide le prix et je souhaite fixer un rendez-vous » : le client peut ensuite choisir son rendez-vous. Sans effet sur les formules (abonnements), toujours engageantes.</p>
                </div>
                <label className="flex items-center gap-2.5 cursor-pointer">
                    <input type="checkbox" className="accent-brand-600" checked={engage} onChange={(e) => { setEngage(e.target.checked); enregistrerEngagement(e.target.checked); }} />
                    <span className="text-sm text-content font-bold">La signature du devis engage le client</span>
                </label>
            </section>
            <section className="space-y-3 p-4 rounded-2xl bg-surface-soft border border-border">
                <div>
                    <h3 className="text-sm font-bold text-content">Devis sans réponse</h3>
                    <p className="text-[11px] text-content-muted mt-0.5">Passé ce délai, le devis et son dossier passent en « Abandonné ». Si le client ouvre ensuite le lien, il lit que le délai est dépassé et qu'il doit refaire une demande.</p>
                </div>
                <label className="flex items-center gap-2.5 cursor-pointer">
                    <input type="checkbox" className="accent-brand-600" checked={actif} onChange={(e) => { setActif(e.target.checked); enregistrer(e.target.checked, jours); }} />
                    <span className="text-sm text-content font-bold">Abandonner un devis resté sans réponse</span>
                </label>
                {actif && (
                    <label className="flex items-center gap-2 text-sm text-content">
                        Au bout de
                        <input type="number" min={1} max={365} className="w-20 bg-surface border border-border rounded-xl px-3 py-2 text-sm text-content outline-none focus:border-brand-500" value={jours}
                            onChange={(e) => setJours(Math.max(1, Math.min(365, Number(e.target.value) || 1)))} onBlur={() => enregistrer(true, jours)} />
                        jours
                    </label>
                )}
            </section>
            {message && <p className="text-xs font-semibold text-green-600 dark:text-green-400">{message}</p>}
        </div>
    );
}
